// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__26Dl5","label":"Section_label__1TLBK","contentWrap":"Section_contentWrap__2J1Y8","footer":"Section_footer__2HbvW","footerInner":"Section_footerInner__3M7AZ"};